import { useState } from 'react'
import { SITE } from '../data/fleet'
import { sendContact } from '../lib/api'

const EMPTY = { name: '', phone: '', email: '', message: '' }

function validate(values) {
  const errors = {}
  if (!values.name.trim()) errors.name = 'Who are we replying to?'
  if (
    values.phone.replace(/\D/g, '').length < 10 &&
    !/\S+@\S+\.\S+/.test(values.email)
  ) {
    errors.phone = 'Leave a phone number or an email so we can reach you.'
  }
  if (!values.message.trim()) errors.message = 'What can we help with?'
  return errors
}

/* Plain contact form. Booking happens on the reserve pages, not here. */
export default function ContactForm() {
  const [values, setValues] = useState(EMPTY)
  const [errors, setErrors] = useState({})
  const [state, setState] = useState('idle')
  const [message, setMessage] = useState(null)

  function update(field) {
    return (e) => {
      const { value } = e.target
      setValues((v) => ({ ...v, [field]: value }))
      setErrors((prev) => {
        if (!prev[field]) return prev
        const next = { ...prev }
        delete next[field]
        return next
      })
    }
  }

  async function handleSubmit() {
    const found = validate(values)
    setErrors(found)
    if (Object.keys(found).length > 0) return

    setState('sending')
    try {
      await sendContact(values)
      setState('sent')
      setValues(EMPTY)
    } catch (err) {
      setMessage(err.message)
      setState('error')
    }
  }

  function field(name, label, input) {
    return (
      <div className={`field ${errors[name] ? 'field--error' : ''}`}>
        <label htmlFor={name}>{label}</label>
        {input}
        {errors[name] && (
          <span className="field__error" role="alert">
            {errors[name]}
          </span>
        )}
      </div>
    )
  }

  return (
    <section className="section request" id="contact">
      <div className="wrap request__grid">
        <div>
          <span className="eyebrow eyebrow--dark">Contact</span>
          <h2>Questions before you book?</h2>
          <p className="hero__sub">
            Odd-size load, a site we haven&rsquo;t listed, a long-term rate for
            a multi-week job &mdash; ask and we&rsquo;ll tell you straight.
          </p>
          <p className="hero__terms">
            Faster by phone: <a href={SITE.phoneHref}>{SITE.phone}</a>
          </p>
        </div>

        <div className="form">
          {state === 'sent' ? (
            <div className="form__status">
              Got it. We reply during dispatch windows &mdash; mornings and
              evenings. Need an answer sooner, call {SITE.phone}.
            </div>
          ) : (
            <>
              {field(
                'name',
                'Your name',
                <input
                  id="name"
                  value={values.name}
                  onChange={update('name')}
                  autoComplete="name"
                />,
              )}

              <div className="form__row form__row--2">
                {field(
                  'phone',
                  'Mobile',
                  <input
                    id="phone"
                    type="tel"
                    inputMode="tel"
                    value={values.phone}
                    onChange={update('phone')}
                    autoComplete="tel"
                  />,
                )}
                {field(
                  'email',
                  'Email',
                  <input
                    id="email"
                    type="email"
                    value={values.email}
                    onChange={update('email')}
                    autoComplete="email"
                  />,
                )}
              </div>

              {field(
                'message',
                'What do you need?',
                <textarea
                  id="message"
                  value={values.message}
                  onChange={update('message')}
                  placeholder="Tell us about the job"
                />,
              )}

              {state === 'error' && (
                <div className="form__status form__status--error" role="alert">
                  That didn&rsquo;t send. {message} Call {SITE.phone} instead.
                </div>
              )}

              <button
                type="button"
                className="btn btn--primary btn--wide"
                onClick={handleSubmit}
                disabled={state === 'sending'}
              >
                {state === 'sending' ? 'Sending\u2026' : 'Send message'}
              </button>
            </>
          )}
        </div>
      </div>
    </section>
  )
}
